var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-modal',{attrs:{"active":_vm.active,"type":"small"},on:{"closed":function($event){return _vm.$emit('closed')}}},[_c('cart-product-form',{attrs:{"model":_vm.data},on:{"updated":_vm.handleUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }